import { render, staticRenderFns } from "./NbNumberedCardForm.vue?vue&type=template&id=18052155&scoped=true&"
import script from "./NbNumberedCardForm.vue?vue&type=script&lang=js&"
export * from "./NbNumberedCardForm.vue?vue&type=script&lang=js&"
import style0 from "./NbNumberedCardForm.vue?vue&type=style&index=0&id=18052155&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18052155",
  null
  
)

export default component.exports